export default __webpack_public_path__ + "static/media/GHSI Special Board Minutes 9 December.fde56bf9.pdf";